import React, { useEffect, useState } from "react";
import "../../../../Assets/Styles/Chatbot.scss";
import "../../../../Assets/Styles/Communication.scss";
import AskMeBot from "./AskMeBot";
import CXBot from "./CXBot";

const Chatbot = (props) => {
  const [TabIds] = useState(["ask-me-tab", "cx-bot-tab"]);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0]?.label_value;
  };

  useEffect(() => {
    // setTimeout(() => (chatBotElement.current.className += " is-open"), 150);
    // getTimeoutDurations();
  }, []);

  const handleSelectTab = (TabId) => {
    TabIds.map((Tab) => {
      document.getElementById(Tab).classList.remove("active-tab");
    });
    document.getElementById(TabId).classList.add("active-tab");
    if (TabId === TabIds[0]) {
      document.getElementById("chatbot-tab-indicator").style.transform = "none";
      props.SetChatbotType("ASK_ME_BOT");
    } else {
      document.getElementById("chatbot-tab-indicator").style.transform =
        "translateX(96px)";
      props.SetChatbotType("CX_BOT");
    }
  };

  return (
    <div className="chatbot">
      <div className={props.IsOpen ? "chatbot-tabs is-open" : "chatbot-tabs"}>
        <section className="tabs-holder">
          <div
            className="tab-item"
            onClick={() => handleSelectTab("ask-me-tab")}
          >
            <p
              id="ask-me-tab"
              className={
                props.ChatbotType === "ASK_ME_BOT"
                  ? "tab-name active-tab"
                  : "tab-name"
              }
            >
              {translateText("ask_me")}
            </p>
          </div>
          <div
            className="tab-item"
            onClick={() => handleSelectTab("cx-bot-tab")}
          >
            <p
              id="cx-bot-tab"
              className={
                props.ChatbotType === "CX_BOT"
                  ? "tab-name active-tab"
                  : "tab-name"
              }
            >
              CX Copilot
            </p>
          </div>
          <span
            id="chatbot-tab-indicator"
            style={
              props.ChatbotType === "CX_BOT"
                ? { transform: "translateX(96px)" }
                : {}
            }
          ></span>
        </section>
      </div>
      <div
        style={
          props.ChatbotType === "CX_BOT" && props.IsOpen
            ? { opacity: 1 }
            : { opacity: 0, zIndex: "-1" }
        }
      >
        <CXBot
          LangData={props.LangData}
          IsOpen={props.IsOpen}
          SetIsOpen={(Bool) => props.SetIsOpen(Bool)}
          Close={(LastType) => props.Close(LastType)}
          UserInfo={props.UserInfo}
          SetChatbotType={(Type) => props.SetChatbotType(Type)}
          ChangedCandidateBookmark={props.ChangedCandidateBookmark}
          ChangedJPAReaction={props.ChangedJPAReaction}
        />
      </div>
      <div
        style={
          props.ChatbotType === "ASK_ME_BOT" && props.IsOpen
            ? { opacity: 1 }
            : { opacity: 0, zIndex: "-1" }
        }
      >
        <AskMeBot
          LangData={props.LangData}
          IsOpen={props.IsOpen}
          SetIsOpen={(Bool) => props.SetIsOpen(Bool)}
          Close={(LastType) => props.Close(LastType)}
          UserInfo={props.UserInfo}
        />
      </div>
    </div>
  );
};

export default Chatbot;
